import { useQuery } from "@apollo/client";
import Errors from "components/base/Errors";
import { InlineSpinner } from "components/base/Spinner";
import ContainerizationView from "components/shared/ContainerizationView";
import moment from "moment";
import { v4 } from "uuid";
import { FETCH_PLAN_SUMMARY } from "./graphql";
import PlanLines from "./PlanLines";

const CombinedPlanSummary = ({ id, shippingZone }) => {
  const { loading, error, data } = useQuery(FETCH_PLAN_SUMMARY, {
    variables: { id },
    fetchPolicy: "network-only",
  });

  if (loading)
    return (
      <div className="p-10 relative">
        <InlineSpinner />
      </div>
    );
  if (error) return <Errors error={error} />;

  const lines = data.productionPlan.finalLines.reduce((res, i) => {
    const found = res.find(
      (x) =>
        x.product.id === i.product.id &&
        x.salesPrice === i.salesPrice &&
        x.discountPercentage === i.discountPercentage,
    );
    if (found)
      return res.map((x) =>
        x.id === found.id
          ? {
              ...x,
              finalQty: x.finalQty + i.finalQty,
              totalCartons: x.totalCartons + i.totalCartons,
              totalGrossWeight: x.totalGrossWeight + i.totalGrossWeight,
              totalCbm: x.totalCbm + i.totalCbm,
              totalCost: x.totalCost + i.totalCost,
              totalPrice: x.totalPrice + i.totalPrice,
              readyDate: moment.max([moment(x.readyDate), moment(i.readyDate)]),
            }
          : x,
      );
    return [...res, { ...i, id: v4() }];
  }, []);

  return (
    <div>
      <h5>Plan Summary</h5>
      <div className="opacity-70">Original Plan and additional plans.</div>
      <div className="mt-2">
        <PlanLines
          originalPlan={data.productionPlan}
          lines={lines}
          requiredCertificateTypes={
            data.productionPlan.requiredCertificateTypes
          }
          odooSalesOrderWarehouseId={
            data.productionPlan.odooSalesOrderWarehouseId
          }
          disabled
        />
      </div>

      <h5 className="mt-8">Capacity</h5>
      <div className="mt-4">
        <ContainerizationView
          totalCbm={data.productionPlan.finalTotalCbm}
          shippingZone={shippingZone}
          defaultDisabledContainers={["40GP"]}
        />
      </div>
    </div>
  );
};

export default CombinedPlanSummary;
